var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BASE_API_URL, ENDPOINTS } from "./endpoints";
import { getCache, setCache } from "../utils/cache";
const CACHE_KEY = "products_cache";
const CACHE_DURATION = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
export const fetchProducts = (type) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // Check cache first
        const cachedProducts = getCache(CACHE_KEY, CACHE_DURATION);
        if (cachedProducts) {
            console.log("Using cached products");
            return cachedProducts;
        }
        const response = yield fetch(`${BASE_API_URL}${ENDPOINTS.GET_PRODUCTS}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            const errorData = yield response.json().catch(() => ({}));
            throw new Error(errorData.message || "Failed to fetch products");
        }
        const data = yield response.json();
        console.log("Raw response data:", data);
        const parsedBody = JSON.parse(data.body);
        if (!parsedBody.products || !Array.isArray(parsedBody.products)) {
            console.error("Invalid response format:", parsedBody);
            throw new Error("Invalid response format from server");
        }
        console.log(`Received ${parsedBody.products.length} products from API`);
        // Filter products based on the type if provided
        const filteredProducts = type
            ? parsedBody.products.filter((product) => product.meta.Type === type)
            : parsedBody.products;
        // Update cache
        setCache(CACHE_KEY, filteredProducts);
        return filteredProducts;
    }
    catch (error) {
        console.error("Error fetching products:", error);
        throw error;
    }
});
